<header class="header-data">
  <img
    src="/assets/icons/arrow-left.svg"
    class="header-data__element header-data__cursor"
    (click)="handleButton('goBack')"
    [alt]="'COMMONS.EXIT' | i18nextEager"
  />
  <img
    src="/assets/icons/logo.svg"
    alt="{{ 'COMMONS.ACCIONA_LOGO' | i18nextEager }}"
    class="header-data__element header-data__logo"
  />
  <div class="container-title">
    <h5 class="">green energy</h5>
    <span class="separator" *ngIf="columnHeader.title || columnHeader.type === 'items'"></span>
    <span *ngIf="columnHeader.title" class="subtitle">{{ columnHeader.title | i18nextEager | uppercase }}</span>
  </div>
  <div
    *ngIf="columnHeader.type === 'items'"
    class="header-data__container-items header-data__element header-data__element--all-space"
    [ngClass]="{ 'header-data__container-items--start': columnHeader.classStart }"
  >
    <div
      *ngFor="let item of columnHeader.data"
      class="header-data__item"
      [ngClass]="{
        'header-data__item--vertical-align-bottom': !item.label,
        'header-data__item--margin-left': columnHeader.classStart
      }"
    >
      <span *ngIf="item.label" class="header-data__item-title">{{ item.label | i18nextEager | uppercase }}</span>
      <div class="header-data__item-field">
        <img
          *ngIf="item.icon && item?.icon !== 'mail'"
          class="header-data__item-icon"
          src="{{ '/assets/icons/' + item.icon + '.svg' }}"
          (click)="handleButton(item.action)"
          alt="{{ item.icon }}"
        />
        <a
          *ngIf="item.icon && item?.icon === 'mail'"
          href="{{ 'mailto:' + item.action }}"
          class="header-data__icon-mail"
        ></a>
        <span *ngFor="let field of item.field">
          {{ field }}
        </span>
      </div>
    </div>
  </div>
  <div
    *ngIf="columnHeader.type === 'buttons'"
    class="header-data__container-items header-data__container-items--end header-data__element header-data__element--all-space"
  >
    <div class="header-data__container-buttons">
      <button
        *ngFor="let item of columnHeader.data"
        class="{{ item.buttonClass }} header-data__button"
        [disabled]="item.disabled"
        (click)="handleButton(item.action)"
      >
        {{ item.label | i18nextEager }}
      </button>
    </div>
  </div>
</header>
